export default "__VITE_ASSET__rcVazLVt__"